import { useEffect } from "react";
import { AppShell } from "./components/Shell";
import { RouterProvider, useRouter } from "./router";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import PeoplePage from "./pages/PeoplePage";
import AlumniPage from "./pages/AlumniPage";
import ResearchPage from "./pages/ResearchPage";
import ProjectsPage from "./pages/ProjectsPage";
import PublicationsPage from "./pages/PublicationsPage";
import NewsPage from "./pages/NewsPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";

const pageTitles = {
  home: "최정혜 교수 연구실 · Yonsei School of Business",
  about: "최정혜 교수 · 최정혜 교수 연구실",
  people: "구성원 · 최정혜 교수 연구실",
  alumni: "졸업생 · 최정혜 교수 연구실",
  research: "연구 · 최정혜 교수 연구실",
  projects: "연구 지원 · 최정혜 교수 연구실",
  publications: "출판 기록 · 최정혜 교수 연구실",
  news: "수상과 활동 · 최정혜 교수 연구실",
  contact: "연락처 · 최정혜 교수 연구실",
  "not-found": "페이지를 찾을 수 없습니다 · 최정혜 교수 연구실"
} as const;

function RoutedApp() {
  const { route } = useRouter();

  useEffect(() => {
    document.title = pageTitles[route];
    const main = document.getElementById("main");
    main?.focus({ preventScroll: true });
  }, [route]);

  const page = {
    home: <HomePage />,
    about: <AboutPage />,
    people: <PeoplePage />,
    alumni: <AlumniPage />,
    research: <ResearchPage />,
    projects: <ProjectsPage />,
    publications: <PublicationsPage />,
    news: <NewsPage />,
    contact: <ContactPage />,
    "not-found": <NotFoundPage />
  }[route];

  return <AppShell>{page}</AppShell>;
}

export default function App() {
  return (
    <RouterProvider>
      <RoutedApp />
    </RouterProvider>
  );
}
